import { Alert, Widget } from "../types";
import { createAlertFromDefinition } from "./alerts";
import { AlertDefinitionKey } from "./keys";
import { ProcedureKey } from "./procedures";
import { WidgetKey } from "./widgets";

export const initialAlerts: Alert[] = [
  // {
  //   ...createAlertFromDefinition(AlertDefinitionKey.HIGH_WIND_SPEED),
  //   id: "0",
  //   interacted: false,
  // },
  {
    ...createAlertFromDefinition(AlertDefinitionKey.TROLLEY_2_WINCH_DISABLED),
    id: "1",
    interacted: true,
  },
  {
    ...createAlertFromDefinition(
      AlertDefinitionKey.TACKLE_2_BRAKE_OIL_FILTER_CLOGGED
    ),
    id: "2",
    interacted: true,
  },
  {
    ...createAlertFromDefinition(
      AlertDefinitionKey.MAIN_HOIST_DRUM_ROPE_LAYER_UNEVEN
    ),
    id: "3",
    interacted: true,
  },
  {
    ...createAlertFromDefinition(
      AlertDefinitionKey.MAIN_HOIST_BRAKE_FILTER_BLOCKED
    ),
    id: "4",
    interacted: true,
  },
];

export const initialWidgets: Widget[] = [
  { id: "1", type: WidgetKey.GREASING, alerts: 0, warnings: 0 },
  { id: "2", type: WidgetKey.TUGGER_1, alerts: 0, warnings: 0 },
  { id: "3", type: WidgetKey.ANTICOLLISION, alerts: 0, warnings: 0 },
  { id: "4", type: WidgetKey.SPEEDLIMITS, alerts: 0, warnings: 0 },
  { id: "6", type: WidgetKey.BLOCKTRAVEL, alerts: 0, warnings: 0 },
  { id: "7", type: WidgetKey.LEGCAPACITY, alerts: 0, warnings: 0 },
  { id: "8", type: WidgetKey.TUGGER_2, alerts: 0, warnings: 0 },
  { id: "5", type: WidgetKey.SPEEDLIMITS, alerts: 0, warnings: 0 },
];

export const initialProcedureKey = ProcedureKey.LIFTING;
